<template>
  <div class="btn-group pull-right">
    <button type="button" class="btn btn-sm btn-default dropdown-toggle left" data-toggle="dropdown"><i class="fa fa-cog"></i> <span>Optionen</span></button>
    <ul class="dropdown-menu pull-right" role="menu">
      <li v-show="$route.path !== '/admin/user'"><router-link to="/admin/user">Benutzerberchrigungen</router-link></li>
      <li v-show="$route.path !== '/admin/role'"><router-link to="/admin/role">Rollenmanagement</router-link></li>
      <li v-show="$route.path !== '/admin/module'"><router-link to="/admin/module">Modulkonfiguration</router-link></li>
      <li v-show="$route.path !== '/admin/navigation'"><router-link to="/admin/navigation">Menükonfiguration</router-link></li>
      <li v-show="$route.path !== '/admin/charts'"><router-link to="/admin/charts">Graffenkonfiguration</router-link></li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "LinksBox"
  }
</script>

<style scoped>

</style>
